import React from 'react';
import { useTheme } from '@mui/material';
import BaseAvailableFactoringOverlay from '@fingo/lib/features/factoring/components/overlays/BaseAvailableFactoringOverlay';
import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';

const AvailableFactoringOverlay = () => {
  const theme = useTheme();
  const InformationIcon = theme.branding.icons.information;

  return (
    <BaseAvailableFactoringOverlay
      title="No tienes facturas disponibles"
      description="No cuentas con facturas emitidas o que cumplan condiciones para ser financiadas."
      overlayProps={{
        IconComponent: InformationIcon,
        iconProps: { sx: { width: 60, height: 'auto' } },
      }}
      titleProps={{ variant: 'medium_2', color: 'primary.A400', fontWeight: 400 }}
      bodyProps={{ variant: 'small_2', fontWeight: 400, color: 'gray.A400' }}
      credentialsSource={REQUESTING_PLATFORM_TO_CODES.BCH}
    />
  );
};

export default AvailableFactoringOverlay;
